'use strict';
const angular = require('angular');

export class paymentComponent {
  constructor(StripeElements, Auth, PaymentService, BankingAccountsService, Config) {
    'ngInject';

    this.targetAccountsConfig = Config.getModuleConfig(Config.Modules.Payment).getTargetAccounts();

    this.APPLICATION_FEE_PERCENT = 0.005;   // 0.5%
    this.ACH_CAP_AMOUNT = 5.0;  // $5 CAP

    this.amount = 0;

    this.activeTab = 1;

    this.StripeElements = StripeElements;
    this.PaymentService = PaymentService;

    this.Auth = Auth;
    this.bankingAccount = {};
    this.bankingAccounts = [];

    BankingAccountsService.getByUser(data => {
      this.bankingAccounts = data.filter(bankingAccount => bankingAccount.status == 'verified')
        .map(bankingAccount => {

        bankingAccount.label = bankingAccount.account_holder_name + ", ***" + bankingAccount.last4
        
        return bankingAccount;
      });
      if (data && data.length) {
        this.bankingAccount = data[0];
      }
    });

    let user = this.Auth.getCurrentUserSync();
    this.name = user.firstName +  ' ' + user.lastName;

    var elements = StripeElements.elements({locale: 'en_US'});
    var element = elements.create('card', {
      style: {
        base: {
          color: '#32325d',
          //lineHeight: '18px',
          //fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          //fontSmoothing: 'antialiased',
          fontSize: 'initial',
          '::placeholder': {
            color: '#aaa'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
    });

    element.on('change', (e) => {
      this.cardErrors = e.error ? e.error.message : ''
    });

    this.element = element;

    this.pp = {
      env: "sandbox", // or: "production"

      locale: 'en_US',

      // https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/customize-button/
      style: {
        size: 'small',
        color: 'gold',
        shape: 'pill',
        label: 'pay'
      },

      client: {
        sandbox:    'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R',
        production: ''
      },

      // payment() is called when the button is clicked
      payment: (data, actions) => {
        // Make a call to the REST api to create the payment
        return actions.payment.create({
          payment: {
            transactions: [
              {
                amount: { total: '0.01', currency: 'USD' }
              }
            ]
          }
        });
      },

      // onAuthorize() is called when the buyer approves the payment
      onAuthorize: (data, actions) => {
        // Make a call to the REST api to execute the payment
        return actions.payment.execute().then(() => {

          this.PaymentService.save({
            method: 'paypal',
            amount: this.amount,
            subject: this.subject,
            success: true,
            livemode: this.pp.env !== 'sandbox',
            payload: data,
            meta: {
              creationUser: this.Auth.getCurrentUserSync()._id
            }
          });

          alert('Payment Complete!');
        });
      },

      onCancel: function(data, actions) {
        /*
         * Buyer cancelled the payment
         */
      },

      onError: function(err) {
        /*
         * An error occurred during the transaction
         */
      }
    };
  }

  /**
   * https://support.stripe.com/questions/can-i-charge-my-stripe-fees-to-my-customers
   * https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
   *
   * P_charge = (P_goal + F_fixed) / (1 - F_percent)
   *
   * F_fixed = Fixed fee (paypal & stripe = 0.3)
   * F_percent = Percent fee (paypal & stripe = 2,9%)
   *
   * @returns {number}
   */
  getAmountWithSurcharge(FIXED, PERCENT, FEE, CAP) {

    let FEE_AMOUNT = this.amount * FEE;

    // calc the exact value
    let exactAmount = ((this.amount + FIXED + FEE_AMOUNT) / (1 - PERCENT));

    if (CAP) {
      let capAmount = this.amount + FEE_AMOUNT + CAP;

      if (capAmount < exactAmount)
        exactAmount = capAmount;
    }

    // round correctly
    return this.roundCorrectly(exactAmount);
  }

  roundCorrectly(exactAmount) {
    return Math.round(exactAmount * 100) / 100;
  }

  getAmountByType(type, amount) {
    switch (type) {
      case 0:
        return this.getAmountWithSurcharge(0.30, 0.029, 0);
        break;
      case 1:
        return this.getAmountWithSurcharge(0.30, 0.029, this.APPLICATION_FEE_PERCENT);
        break;
      case 2:
        return this.getAmountWithSurcharge(0, 0.008, this.APPLICATION_FEE_PERCENT, this.ACH_CAP_AMOUNT);
        break;
    }
  }

  /*
    ¯\_(ツ)_/¯
    Always be careful when handling numbers in JS:

    let x = 115 * 0.005;
    console.log(x) // 0.5750000000000001

    let y = Math.round(x*100)/100;
    console.log(y) // 0.58

    console.log(y * 10) // 5.8
    console.log(y* 100) // 57.99999999999999 !!!?
   */

  payByACH() {
    this.stripeError = false;
    this.stripeProcessing = true;

    let user = this.Auth.getCurrentUserSync();

    let name = user.firstName;
    if (user.middleName)
      name += " " + user.middleName;
    name += " " + user.lastName;

    let amountWithSurcharge = this.getAmountWithSurcharge(0, 0.008, this.APPLICATION_FEE_PERCENT, this.ACH_CAP_AMOUNT);

    let result = {
      source: this.bankingAccount.id,
      metadata: {
        fullName: name,
        netAmount: Math.round(this.amount * 100),
        creationDate: new Date(),
        creationUser: this.Auth.getCurrentUserSync()._id
      }
    };

    if (this.Auth.getCurrentUserSync().webaccessId) {
      result.metadata.webaccessId = this.Auth.getCurrentUserSync().webaccessId;
    }

    if (this.targetAccount) {
      result.metadata.targetAccount = this.targetAccount;
    }

    result.amount = Math.round(amountWithSurcharge*100);  // in stripe: All amounts are in the "smallest common currency unit"
    result.subject = this.subject;
    result.fee = Math.round(this.roundCorrectly(this.amount * this.APPLICATION_FEE_PERCENT) * 100);

    this.PaymentService.stripePaymentACH({userId: user._id}, result, data => {
      this.stripeProcessing = false;
      this.stripeSuccess = data.message;
    }, err => {
      this.stripeProcessing = false;
      this.stripeError = err.message;
    });
 }

  payByCard() {
    this.stripeError = false;
    this.stripeProcessing = true;

    let user = this.Auth.getCurrentUserSync();

    this.StripeElements.createToken(this.element,{
      email: user.email
    }).then((result) => {
      // Handle result.error or result.token
      console.log(result);

      let name = user.firstName;
      if (user.middleName)
        name += " " + user.middleName;
      name += " " + user.lastName;

      let amountWithSurcharge = this.getAmountWithSurcharge(0.30, 0.029, this.APPLICATION_FEE_PERCENT);

      result.metadata = {
        fullName: name,
        netAmount: Math.round(this.amount * 100),
        creationDate: new Date(),
        creationUser: this.Auth.getCurrentUserSync()._id
      };

      if (this.targetAccount) {
        result.metadata.targetAccount = this.targetAccount;
      }

      if (this.Auth.getCurrentUserSync().webaccessId) {
        result.metadata.webaccessId = this.Auth.getCurrentUserSync().webaccessId;
      }

      result.amount = Math.round(amountWithSurcharge*100);  // in stripe: All amounts are in the "smallest common currency unit"
      result.subject = this.subject;
      result.fee = Math.round(this.roundCorrectly(this.amount * this.APPLICATION_FEE_PERCENT) * 100);

      if (!result.error) {
        this.PaymentService.stripePayment({userId: user._id}, result, data => {
          this.stripeProcessing = false;
          this.stripeSuccess = data.message;
        }, err => {
          this.stripeProcessing = false;

          let error = err.data.message || 'An unknown error occurred';
          if (error == 'Invalid positive integer')
            error = 'Invalid Amount';
          this.stripeError = error;
        })
      } else {
        this.stripeProcessing = false;

        this.stripeError = result.error.message;
        console.log(result.error);
      }
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.targetAccounts && this.targetAccountsConfig[this.config.targetAccounts]) {
     this.targetAccountRequired = true;
     this.targetAccounts = this.targetAccountsConfig[this.config.targetAccounts];
    } else {
      this.targetAccountRequired = false;
    }
  };

  ok() {
    this.close({$value: this.client});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getInfoText(key) {
    let idx = this.clients.findIndex(o => o.key == key);
    return this.clients[idx].info || '';
  }

}

export default angular.module('condu.paymentComponent', [])
  .component('paymentComponent', {
    template: require('./payment.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: paymentComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/payment/payment.component.js